import { render, staticRenderFns } from "./fanxy.vue?vue&type=template&id=2e08ca07&scoped=true&"
import script from "./fanxy.vue?vue&type=script&lang=js&"
export * from "./fanxy.vue?vue&type=script&lang=js&"
import style0 from "./fanxy.vue?vue&type=style&index=0&id=2e08ca07&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e08ca07",
  null
  
)

export default component.exports